import React from "react";
import JSONViewer from "react-json-viewer";

interface JsonViewerProps {
  object: any;
}

const JsonViewer: React.FC<JsonViewerProps> = (props) => {
  return <JSONViewer json={props.object} />;
};

export default JsonViewer;
